module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9TYdw"))).then(() => parcelRequire('hEqeo'));